const restrictEditingImportantFields = (jobStatus, userIsNotInterpreter, isGodmode) => {
  return (!['published', 'applied', 'accepted'].includes(jobStatus) && userIsNotInterpreter) || isGodmode;
};

export default {
  restrictEditingImportantFields
};
